export default function linkResolver(doc) {
  // console.log("linkResolver", doc);

  if (doc.type === "main_page") {
    return "/";
  }

  if (
    doc.type === "page" ||
    doc.type === "document" ||
    doc.type === "landing"
  ) {
    return `/${doc.uid}`;
  }

  if (doc.link_type === "Document") {
    return "/" + doc.slug;
  }

  return "/";
}
